import React, { useState } from "react";

import { SubscriptionActionsContext } from "./subscriptions-action-context";

interface SubscriptionActionsContextWrapperProps {
  children: React.ReactNode;
}

const SubscriptionActionsContextWrapper = ({
  children,
}: SubscriptionActionsContextWrapperProps) => {
  const [isSubscriptionActionLoading, setIsSubscriptionActionLoading] =
    useState<boolean>(false);

  const subscriptionActionsContextValue = {
    isSubscriptionActionLoading,
    setIsSubscriptionActionLoading,
  };

  return (
    <SubscriptionActionsContext.Provider
      value={subscriptionActionsContextValue}
    >
      {children}
    </SubscriptionActionsContext.Provider>
  );
};

export default SubscriptionActionsContextWrapper;
